<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :search.sync="paramsSearch"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        :key="tableKey"
        v-model="form"
        :row-class-name="cellClassNameFn"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="handleDel"
        @sort-change="sortChange"
        @search-change="searchChange"
        @selection-change="handleSelectionChange"
      >
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="margin-bottom: 0; background: #fff"
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <!-- <el-button
              size="small"
              v-if="permissions['chain:companysettle:export']"
              @click="exportExc(scope.row, scope.index)"
            >
              导出
            </el-button> -->
            <span class="reset" @click="reset"> 重置筛选条件 </span>
            <div class="expand" @click="expandSearch">
              <span v-if="isExpand == true"
                >收起 <i class="el-icon-arrow-up"></i
              ></span>
              <span v-if="isExpand == false"
                >展开 <i class="el-icon-arrow-down"></i
              ></span>
            </div>
          </div>
        </template>

        <template slot="menuLeft" slot-scope="scope">
          <div class="menu-left">
            <div class="checked">
              <el-checkbox
                :value="multipleSelection.length > 0"
                @change="changeAll"
                style="margin-right: 8px"
              ></el-checkbox>
              已选<span> {{ multipleSelection.length }} </span>个
            </div>
            <div class="statistics">
              <i class="el-icon-info"></i>
              <label>运单总数：</label
              ><span
                >{{ statisForm.total
                }}<span style="color: #313133; margin-left: 10px">;</span></span
              >
              <label>已核算运单数：</label
              ><span
                >{{ statisForm.settle
                }}<span style="color: #313133; margin-left: 10px">;</span></span
              >
              <label>已核算运单金额(元)：</label
              ><span
                >{{ statisForm.amtSettle
                }}<span style="color: #313133; margin-left: 10px">;</span></span
              >
              <label>待核算运单数：</label
              ><span
                >{{ statisForm.unsettle
                }}<span style="color: #313133; margin-left: 10px">;</span>
              </span>
              <label>驳回运单数：</label
              ><span>{{ statisForm.reject || 0 }}</span>
            </div>
            <el-button
              size="mini"
              type="primary"
              :disabled="multipleSelection.length == 0"
              :loading="tableLoading"
              @click="batchMerge"
            >
              合并结算单
            </el-button>
            <el-button
              v-if="permissions['chain:companysettle:scan']"
              size="small"
              @click="scanCard"
            >
              扫描电子结算卡二维码结算</el-button
            >
          </div>
        </template>
        <!-- <template slot="header" slot-scope="{ row }">
          <div
            style="
              display: inline-block;
              position: relative;
              top: -3px;
              margin-left: 10px;
            "
          >
           
          </div>
        </template> -->
        <template slot="projectInfoId" slot-scope="scope">
          <span>{{ scope.row.projectName }}</span>
        </template>
        <template slot="waybillCnt" slot-scope="scope">
          <div
            style="color: #409eff; cursor: pointer"
            @click="waybillDetail(scope.row)"
          >
            {{ scope.row.waybillCnt }}
          </div>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button
            type="text"
            v-if="
              permissions['chain:companysettle:check'] &&
              (scope.row.status == 1 || scope.row.status == 5)
            "
            size="small"
            plain
            @click="billAccount(scope.row, scope.index, 1)"
          >
            账单核算</el-button
          >
          <el-button
            type="text"
            v-if="
              permissions['chain:companysettle:check'] &&
              (scope.row.status == 2 ||
                scope.row.status == 3 ||
                scope.row.status == 9)
            "
            size="small"
            plain
            @click="billAccount(scope.row, scope.index, 2)"
          >
            查看账单</el-button
          >
          <el-dropdown
            size="mini"
            style="margin-left: 4px"
            v-if="
              (permissions['chain:companysettle:get'] &&
                (scope.row.status == 2 ||
                  scope.row.status == 3 ||
                  scope.row.status == 9)) ||
              (permissions['chain:companysettle:reject'] &&
                (scope.row.status == 1 || scope.row.status == 5)) ||
              (permissions['chain:companysettle:receiptInfo'] && isCheckOpen) ||
              (permissions['chain:companysettle:createPlan'] &&
                (scope.row.status == 1 ||
                  scope.row.status == 2 ||
                  scope.row.status == 3 ||
                  scope.row.status == 9)) ||
              permissions['chain:companysettle:viewPlan'] ||
              (permissions['chain:companysettle:viewProcess'] &&
                (scope.row.status == 2 ||
                  scope.row.status == 3 ||
                  scope.row.status == 9))
            "
          >
            <el-button type="text" size="mini">···</el-button>
            <el-dropdown-menu slot="dropdown">
              <div>
                <el-dropdown-item
                  type="text"
                  v-if="
                    permissions['chain:companysettle:get'] &&
                    (scope.row.status == 2 ||
                      scope.row.status == 3 ||
                      scope.row.status == 9)
                  "
                  size="small"
                  plain
                  @click.native="viewAccountSheet(scope.row, scope.index)"
                >
                  查看核算单</el-dropdown-item
                >
                <el-dropdown-item
                  type="text"
                  v-if="
                    permissions['chain:companysettle:reject'] &&
                    (scope.row.status == 1 || scope.row.status == 5)
                  "
                  size="small"
                  plain
                  @click.native="rejectReq(scope.row, scope.index)"
                >
                  驳回申请</el-dropdown-item
                >
                <el-dropdown-item
                  type="text"
                  v-if="
                    permissions['chain:companysettle:receiptInfo'] &&
                    isCheckOpen
                  "
                  size="small"
                  plain
                  @click.native="receiptInfo(scope.row, scope.index)"
                >
                  回执信息</el-dropdown-item
                >
                <el-dropdown-item
                  size="small"
                  type="text"
                  plain
                  :loading="tableLoading"
                  v-if="
                    permissions['chain:companysettle:createPlan'] &&
                    (scope.row.status == 1 ||
                      scope.row.status == 2 ||
                      scope.row.status == 3 ||
                      scope.row.status == 9)
                  "
                  @click.native="createPlan(scope.row)"
                >
                  创建计划
                </el-dropdown-item>
                <el-dropdown-item
                  size="small"
                  type="text"
                  plain
                  :loading="tableLoading"
                  v-if="permissions['chain:companysettle:viewPlan']"
                  @click.native="viewPlanInfo(scope.row)"
                >
                  查看计划
                </el-dropdown-item>
                <el-dropdown-item
                  size="small"
                  type="text"
                  plain
                  :loading="tableLoading"
                  v-if="
                    permissions['chain:companysettle:viewProcess'] &&
                    (scope.row.status == 2 ||
                      scope.row.status == 3 ||
                      scope.row.status == 9)
                  "
                  @click.native="viewProcess(scope.row)"
                >
                  查看流程
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </avue-crud>
    </basic-container>
    <!-- 查看运单 -->
    <el-dialog title="运单详情" :visible.sync="viewVisible">
      <el-table :data="waybillData">
        <el-table-column
          v-for="(item, index) in column"
          :key="index"
          :property="item.property"
          :label="item.label"
          width="105px"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 驳回申请 -->
    <el-dialog
      title="驳回结算"
      class="rejectDialog"
      :visible.sync="rejectVisible"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <el-form
        :model="rejectForm"
        ref="rejectForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="结算单号：">
              <span>{{ rejectForm.settleNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算申请人：">
              <span>{{ rejectForm.agentName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="项目名称：">
              <span>{{ rejectForm.projectName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运单数量：">
              <span>{{ rejectForm.waybillCnt }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="操作人：">
              <span>{{ rejectForm.settleName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :required="true" label="驳回原因："> </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          prop="rejectedRemark"
          :rules="{
            required: true,
            message: '请输入驳回原因',
            trigger: 'blur',
          }"
          label-width="0px"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 12 }"
            placeholder="请输入内容"
            v-model="rejectForm.rejectedRemark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <div style="text-align: center">
          <el-button
            :loading="visibleBtnLoading"
            icon="el-icon-circle-check"
            size="small"
            type="primary"
            @click="confirmReject"
          >
            确认驳回</el-button
          >
          <el-button
            icon="el-icon-circle-close"
            size="small"
            @click="rejectVisible = false"
          >
            取消</el-button
          >
        </div>
      </template>
    </el-dialog>
    <!-- 账单核算 -->
    <!-- <bill-account
      v-if="billVisible"
      :infoForm="infoForm"
      v-on:searchData="refreshChange"
      :visible.sync="billVisible"
    ></bill-account> -->
    <!-- 查看核算单 -->
    <account-sheet
      v-if="accountVisible"
      :accountForm="accountForm"
      v-on:viewWaybill="viewWaybill"
      :visible.sync="accountVisible"
    ></account-sheet>
    <!-- 回执信息 -->
    <receipt-info
      v-if="receiptVisible"
      :info="info"
      :visible.sync="receiptVisible"
    ></receipt-info>
    <!-- 资金计划 -->
    <createPlan
      v-if="planVisible"
      :infoForm="infoForm"
      :visible.sync="planVisible"
    ></createPlan>
    <!-- 查看核算单 -->
    <view-plan
      v-if="viewPlanVisible"
      :info="accountForm"
      :visible.sync="viewPlanVisible"
    ></view-plan>
    <!-- 查看进度 -->
    <view-process
      v-if="viewProcessVisible"
      :accountForm="accountForm"
      :visible.sync="viewProcessVisible"
    ></view-process>
    <!-- //查看核算单特殊企业 -->
    <printPlan
      v-if="printVisible"
      fileName="结算单"
      :accountForm="accountForm"
      :visible.sync="printVisible"
    ></printPlan>
    <waybillDetail
      v-if="waybillVisible"
      :visible.sync="waybillVisible"
      :info="info"
    ></waybillDetail>
  </div>
</template>

<script>
import {
  getPage,
  getObj,
  addObj,
  putObj,
  delObj,
  statisticsPage,
  getSettleWaybill,
  rejectSettle,
  printSettle,
  mergeSettlement,
  checkOpen,
  printCompanyPaymentPlanSettle,
  listDictionaryItem,
} from "@/api/chain/companysettle";
import { getSettleInfo } from "@/api/chain/settleApproval";
import { tableOption } from "@/const/crud/chain/companysettle2";
import { mapGetters } from "vuex";
//引入账单核算
import billAccount from "./billAccount.vue";
import accountSheet from "./accountSheet.vue";
import receiptInfo from "./receiptInfo.vue";
import { expotOut } from "@/util/down.js";
import createPlan from "./createPlan.vue";
import viewPlan from "./viewPlan.vue";
import viewProcess from "./viewProcess.vue";
import printPlan from "./printPlan.vue";
import waybillDetail from "@/components/waybillDialog";

export default {
  name: "companysettle2",
  components: {
    billAccount,
    accountSheet,
    receiptInfo,
    createPlan,
    viewPlan,
    viewProcess,
    printPlan,
    waybillDetail,
  },
  data() {
    return {
      search: {},
      searchInfo:{},
      isExpand: false,
      tableKey: 0,
      selectList: [],
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
      viewVisible: false, //查看运单的弹窗
      rejectVisible: false, //驳回申请的弹窗
      billVisible: false, //账单核算的弹窗
      accountVisible: false, //查看核算单的弹窗
      infoForm: {}, //账单核算需要的数据
      waybillData: [], //查看运单数据
      accountForm: {}, //查看核算单数据
      column: [
        {
          label: "运单号",
          property: "id",
        },
        {
          label: "车牌号",
          property: "truckCode",
        },
        {
          label: "项目合作方",
          property: "projectPartner",
        },
        {
          label: "车队长",
          property: "captainName",
        },
        {
          label: "司机",
          property: "driverName",
        },
        {
          label: "挖机签单员",
          property: "inStaffId",
        },
        {
          label: "出场签单员",
          property: "goStaffId",
        },
        {
          label: "结算价",
          property: "price",
        },
        {
          label: "挖机签单时间",
          property: "inDatetime",
        },
        {
          label: "出场签单时间",
          property: "goDatetime",
        },
        {
          label: "完成时间",
          property: "createDatetime",
        },
      ], //查看运单数据列数据
      rejectForm: {}, //驳回申请的数据
      visibleBtnLoading: false, //弹窗按钮loadding
      statisForm: {
        amtSettle: 0,
        reject: 0,
        settle: 0,
        total: 0,
        unsettle: 0,
      },
      searchDom: {},
      multipleSelection: [],
      info: {},
      receiptVisible: false,
      isCheckOpen: false, //企业是否开启结算单回执
      planVisible: false, //资金计划弹窗
      viewPlanVisible: false, //查看资金计划弹窗
      viewProcessVisible: false, //查看流程弹窗
      printVisible: false, //查看流程弹窗
      waybillVisible: false,
    };
  },
  created() {
    if(this.$route.query.searchInfo){
      let tmp = JSON.parse(this.$route.query.searchInfo)
      
      this.page= {
        currentPage: tmp.pages.current, // 当前页数
        pageSize: tmp.pages.size, // 每页显示多少条
        ascs: tmp.pages.ascs, //升序字段
        descs: tmp.pages.descs, //降序字段
      }
      this.paramsSearch=tmp.params
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  mounted() {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
    // 检查是否开启结算单回执
    checkOpen({ companyAuthId: "" }).then((res) => {
      this.isCheckOpen = res.data.data;
    });
    this.searchDom = this.$refs.crud.$refs.headerSearch;
    // window.addEventListener("resize", this.func);
  },
  // activated() {
  //   setTimeout(() => {
  //     let tableHeight = document.querySelector(".el-table").offsetTop;
  //     this.$refs.crud.tableHeight = window.innerHeight - tableHeight - 182;
  //     this.$refs.crud.tableOption.height =
  //       window.innerHeight - tableHeight - 182;
  //     this.$refs.crud.doLayout();
  //   }, 100);
  // },
  computed: {
    ...mapGetters(["permissions", "userInfo"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:companysettle:add"] ? true : false,
        delBtn: this.permissions["chain:companysettle:del"] ? true : false,
        editBtn: this.permissions["chain:companysettle:edit"] ? true : false,
        viewBtn: this.permissions["chain:companysettle:get"] ? true : false,
      };
    },
  },
  // watch: {
  //   "searchDom.searchShow": {
  //     handler(newVal, oldVal) {
  //       setTimeout(() => {
  //         let tableHeight = document.querySelector(".el-table").offsetTop;
  //         this.$refs.crud.tableHeight = window.innerHeight - tableHeight - 182;
  //         this.$refs.crud.tableOption.height =
  //           window.innerHeight - tableHeight - 182;
  //         this.$refs.crud.doLayout();
  //       }, 300);
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    expandSearch() {
      this.isExpand = !this.isExpand;
      this.tableOption.searchIcon = this.isExpand ? false : true;
      this.$nextTick(() => {
        this.updateTableHeight();
      });
    },
    updateTableHeight() {
      this.tableOption.height = this.$calculateTableHeight(
        this.$refs.crud.$refs.table
      );
      this.tableKey += 1;
    },
    changeAll(e) {
      if (e) {
        this.$refs.crud.$refs.table.toggleAllSelection();
      } else {
        this.multipleSelection = [];
        this.$refs.crud.$refs.table.clearSelection();
      }
    },
    expotOut,

    // func() {
    //   let tableHeight = document.querySelector(".el-table").offsetTop;
    //   this.$refs.crud.tableHeight = window.innerHeight - tableHeight - 182;
    //   this.$refs.crud.tableOption.height =
    //     window.innerHeight - tableHeight - 182;
    //   this.$refs.crud.doLayout();
    // },
    statisticsPage(params = {}) {
      statisticsPage(Object.assign(params, this.paramsSearch)).then((res) => {
        this.statisForm = res.data.data;
      });
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params = {}) {
      if (params) {
        if (params.hasOwnProperty("applyDatetime")) {
          params.applyDatetimeStart = params.applyDatetime[0];
          params.applyDatetimeEnd = params.applyDatetime[1];
          delete params.applyDatetime;
        }
        if (params.hasOwnProperty("moneyDatetime")) {
          params.moneyDatetimeStart = params.moneyDatetime[0];
          params.moneyDatetimeEnd = params.moneyDatetime[1];
          delete params.moneyDatetime;
        }
        if (params.hasOwnProperty("settleDatetime")) {
          params.settleDatetimeStart = params.settleDatetime[0];
          params.settleDatetimeEnd = params.settleDatetime[1];
          delete params.settleDatetime;
        }
      }

      this.tableLoading = true;
      this.searchInfo = {
        pages: {
          current: page.currentPage,
          size: page.pageSize,
          descs: this.page.descs,
          ascs: this.page.ascs,
        },
        params,
      };
      
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
      this.statisticsPage(params);
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    //账单核算
    billAccount(row, index, type) {
      this.tableLoading = true;
      this.infoForm = row;
      this.infoForm.type = type; //1核算  2查看核算
      //获取运单信息
      let param = {
        companySettleId: row.id,
      };
      getSettleWaybill(param)
        .then((res) => {
          // this.billVisible = true;
          this.tableLoading = false;
          this.infoForm.tableData = res.data.data;
          this.$router.push({
            path: "/billAccountIndex",
            query: {
              infoForm: JSON.stringify(this.infoForm),
              searchInfo:JSON.stringify(this.searchInfo),
            },
          });
          console.log(res, "res");
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    //查看核算单
    viewAccountSheet(row, index) {
      this.tableLoading = true;
      //获取核算单信息
      this.accountForm = row;
      let param = {
        settleId: row.id,
        planId: "",
      };
      listDictionaryItem({ dictionary: this.userInfo.tenantId })
        .then((res) => {
          //在数据字典里面 特殊处理 chain:companysettle:get
          let permission = res.data.data.some((item) => {
            return item.itemValue == "chain:companysettle:get";
          });
          if (res.data.data.length > 0 && permission) {
            printCompanyPaymentPlanSettle(param)
              .then((res) => {
                this.tableLoading = false;
                this.accountForm.tableData = res.data.data;
                this.printVisible = true;
              })
              .catch(() => {
                this.tableLoading = false;
              });
          } else {
            printSettle(param)
              .then((res) => {
                this.tableLoading = false;
                this.accountForm.tableData = res.data.data;
                this.accountVisible = true;
              })
              .catch(() => {
                this.tableLoading = false;
              });
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    //查看运单
    viewWaybill(row, index) {
      this.waybillData = [];
      //获取运单信息
      this.waybillData = waybillData;
      this.viewVisible = true;
    },
    //确认打款
    confirmRemit(row, index) {
      this.$message({
        showClose: false,
        message: "打款功能暂未开发完成，请您耐心等待",
        type: "error",
      });
    },
    //驳回申请
    rejectReq(row, index) {
      //获取运单信息
      this.rejectForm = row;
      this.rejectVisible = true;
    },
    //确认驳回
    confirmReject() {
      this.$refs.rejectForm.validate((valid) => {
        if (valid) {
          this.visibleBtnLoading = true;
          let param = {
            rejectedRemark: this.rejectForm.rejectedRemark,
            settleId: this.rejectForm.id,
          };
          //下面调用接口
          rejectSettle(param)
            .then((res) => {
              this.rejectVisible = false;
              this.visibleBtnLoading = false;
              this.refreshChange();
            })
            .catch(() => {
              this.visibleBtnLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    scanCard() {
      this.$router.push({ path: "/scan/scanCard" });
    },
    //导出
    exportExc() {
      console.log(this.paramsSearch);
      let params = Object.assign({}, this.paramsSearch);
      if (params) {
        if (params.hasOwnProperty("applyDatetime")) {
          params.applyDatetimeStart = params.applyDatetime[0];
          params.applyDatetimeEnd = params.applyDatetime[1];
          delete params.applyDatetime;
        }
        if (params.hasOwnProperty("moneyDatetime")) {
          params.moneyDatetimeStart = params.moneyDatetime[0];
          params.moneyDatetimeEnd = params.moneyDatetime[1];
          delete params.moneyDatetime;
        }
        if (params.hasOwnProperty("settleDatetime")) {
          params.settleDatetimeStart = params.settleDatetime[0];
          params.settleDatetimeEnd = params.settleDatetime[1];
          delete params.settleDatetime;
        }
      }
      this.expotOut(params, "/chain/companysettle/exportXls", "财务结算");

      // let params = Object.assign({}, form);
      // if (params.goDatetime && params.goDatetime.length > 0) {
      //   params.goDatetimeStart = params.goDatetime[0];
      //   params.goDatetimeEnd = params.goDatetime[1];
      // }
      // delete params.goDatetime;
      // let url = '/chain/excelExport/createByCode'
      // let name = '车辆进出台账'
      // this.$refs.crud.rowExcel();
    },
    cellClassNameFn(row) {
      if (row.row.paymentNo) {
        // 通过自定义样式隐藏复选框
        return "table-column-hidden";
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchMerge() {
      console.log(this.multipleSelection);
      let param = this.multipleSelection.map((item) => {
        return {
          companyAuthId: item.companyAuthId,
          agentInfoId: item.agentInfoId,
          projectInfoId: item.projectInfoId,
          applyId: item.applyId,
          id: item.id,
        };
      });
      this.$confirm("确定合并结算单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true;
          mergeSettlement(param)
            .then((res) => {
              this.tableLoading = false;
              this.$message.success(res.data.msg);
              this.getPage(this.page);
            })
            .catch(() => {
              this.tableLoading = false;
            });
        })
        .catch(function (err) {});
    },
    receiptInfo(row) {
      this.info = row;
      this.receiptVisible = true;
    },
    //创建资金计划
    createPlan(row) {
      this.tableLoading = true;
      this.infoForm = row;
      //获取运单信息
      let param = {
        companySettleId: this.infoForm.id,
        isPlan: 1,
      };
      getSettleWaybill(param)
        .then((res) => {
          this.planVisible = true;
          this.tableLoading = false;
          this.infoForm.tableData = res.data.data;
          console.log(res, "res");
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    //查看计划
    viewPlanInfo(row, index) {
      this.accountForm = row;
      this.viewPlanVisible = true;
    },
    //查看流程
    viewProcess(row, index) {
      this.tableLoading = true;
      getSettleInfo(row.id)
        .then((res) => {
          this.tableLoading = false;
          this.accountForm = res.data.data;
          this.viewProcessVisible = true;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    //查看运单详情
    waybillDetail(row) {
      //结算单号
      this.info = {
        companySettleNo: row.settleNo,
        isReject: "1", //查询已驳回的数据
      };
      // this.waybillVisible = true;
      this.$router.push({
        path: "/waybillDetailList/index",
        query: this.info,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
/deep/ .rejectDialog {
  .el-dialog__body {
    padding-top: 0;
  }
  .el-form .el-form-item {
    margin-bottom: 0px;
  }
}
/deep/ .el-table .el-table__fixed-right {
  height: auto !important;
  bottom: 8px !important;
  &::before {
    background-color: transparent;
  }
}
.statistics {
  // display: flex;
  // align-items: center;
  // white-space:nowrap;
  padding: 0 16px;
  border: 3px;
  line-height: 32px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  border: 1px solid #35b1ff;
  background: #e9f2ff;
  margin-right: 16px;
  span {
    color: #35b1ff;
    margin-right: 10px;
  }
  i {
    color: #35b1ff;
    margin-right: 9px;
  }
}
/deep/.el-dropdown-menu_item {
  font-weight: 400;
  font-size: 14px;
  color: #313133;
}
.reset {
  margin-left: 14px;
}
.headerContent {
  margin-left: 105px;
}
.menu-left {
  display: flex;
  align-items: center;
  /deep/.el-button {
    margin-bottom: 0;
  }
}
/deep/.headerContent ~ .el-button {
  display: none;
}
/deep/.avue-crud__tip {
  display: none;
}
</style>
